//src/services/community.api.js
import { apiRequest } from "./api";

export const joinCommunity = (email) => {
  return apiRequest("/community/join", {
    method: "POST",
    body: JSON.stringify({ email }),
  });
};
